// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"687":"d22f19db","954":"0730e5b2"}[chunkId] + ".css";
};